<!-- <pdf-viewer [src]="pdfSrc" [render-text]="true" [original-size]="false" style="width: 800px; height: 600px"></pdf-viewer> -->
<router-outlet></router-outlet>
